import { Component, OnInit, inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ECLSqlConfigService } from '@lmc-app/core/services/ecl-sql-config.service';
import { SnackbarConstants } from '@lmc-app/shared/constants/snackbar.constant';
import { Loading } from '../../applications/loading';

@Component({
	selector: 'app-sql-ecl-config',
	templateUrl: './ecl-sql-config.component.html',
	styleUrls: ['./ecl-sql-config.component.scss'],
})
export class ECLSqlConfigComponent implements OnInit {
	protected columns = [
		{
			headerName: 'Stage',
			field: 'stage',
			sortable: false,
			width: 40,
		},
		{
			headerName: 'Risk',
			field: 'risk',
			sortable: false,
			width: 40,
		},
		{
			headerName: 'Principal',
			field: 'principal_balance',
			sortable: false,
			editable: true,
		},
		{
			headerName: 'Interest',
			field: 'interest_balance',
			sortable: false,
			editable: true,
		},
	];
	protected eclConfig: ECLConfig[] = [];
	protected filteredECLConfig: ECLConfig[] = [];
	// Loading states
	protected isLoading: boolean = false;
	private readonly _bottomSheet = inject(MatBottomSheet);
	private readonly _snackBar = inject(MatSnackBar);

	constructor(
		private eclSqlConfigService: ECLSqlConfigService,
	) { }

	ngOnInit(): void {
		this.isLoading = true;
		this.getECLConfig();
	}

	getECLConfig() {
		this.eclSqlConfigService.getECLConfig().subscribe({
			next: (res) => {
				this.eclConfig = res;
				this.filteredECLConfig = this.eclConfig;
				this.isLoading = false;
			},
			error: (err) => {
				console.error(err);
				this.isLoading = false;
			},
		});
	}

	protected onCellValueChanged(e: { data: { id: number } }) {
		this._bottomSheet.open(Loading, {
			disableClose: true,
			data: { message: 'Saving' },
		});
		this.eclSqlConfigService.updateECLConfig(e.data).subscribe({
			next: () => {
				this.getECLConfig();
				this._snackBar.open(
					`ECL Config ${e.data.id} is updated.`,
					SnackbarConstants.ACTION_DISMISS,
					SnackbarConstants.DURATION_DISMISS_SHORT
				);
				this._bottomSheet.dismiss();
			},
			error: (error) => {
				this.getECLConfig();
				this._bottomSheet.dismiss();
				console.error(error);
				this._snackBar.open(
					(error.error && (error.error.message && (error.error.message.name || error.error.message))) || 'Error updating ECL Config.',
					SnackbarConstants.ACTION_DISMISS,
					SnackbarConstants.DURATION_DISMISS_SHORT
				);
			},
		});
	}
}
